import React from "react";
import ReactDOM from "react-dom";
import { hideDialog, updateDialog } from "../../actions/dialog";
import { optional } from "../../utils/lang";
import { isNotEmpty } from "../../framework/utils";
import { ACTION_TYPES } from "./mobile/actions";
import M from "../../strings";
import _ from "underscore";

class WizardPagination extends React.Component {
    constructor(props) {
        super(props);
    }

    onStepClick(step) {
        if (this.props.onStepClick && _.isFunction(this.props.onStepClick)) {
            this.props.onStepClick(step);
        }
    }

    render() {
        const paginationSteps = optional(this.props.paginationSteps, 1),
            currentStep = optional(this.props.currentStep, 1),
            paginationItems = [];

        for (let i = 1; i <= paginationSteps; i++) {
            const isActive = i === currentStep;
            paginationItems.push(
                <li
                    key={"pagination-item-" + i}
                    className={"page-item" + (isActive ? " active" : "")}
                >
                    <a
                        className="page-link"
                        onClick={() => this.onStepClick(i)}
                    >
                        {i}
                    </a>
                </li>
            )
        }

        const content = (<>
            <div className="new-survey-wizard__pagination">
                <ul className="pagination pagination--wizard">
                    {paginationItems}
                </ul>
            </div>
            {this.props.subtitle && <div className="modal-content-header__subtitle">{this.props.subtitle}</div>}
        </>)

        return content;
    }
}

export class Wizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 1,
            selected: {},
        }
    }

    componentDidMount() {
        const onEnter = this.props.children[this.state.currentStep - 1].props.onEnter;
        if (_.isFunction(onEnter)) {
            onEnter();
        }

        this.updateDialogActions();
    }

    getMaxSteps() {
        return this.props.children.length;
    }

    getChild(step = 0) {
        if (step == 0) {
            step = this.state.currentStep;
        }

        const index = step - 1;
        
        return this.props.children[index] ?? null;
    }

    getChildProp(prop, step = 0) {
        return this.getChild(step).props[prop];
    }

    prevStep() {
        const currentStep = this.state.currentStep;
        if (currentStep > 1) {
            this.setState(
                {currentStep: currentStep - 1},
                this.updateDialogActions.bind(this)
            )

            const onLeave = this.getChildProp("onLeave", currentStep);
            if (_.isFunction(onLeave)) {
                onLeave();
            }

            const onEnter = this.getChildProp("onEnter", currentStep - 1);
            if (_.isFunction(onEnter)) {
                onEnter();
            }
        }
    }

    nextStep() {
        const currentStep = this.state.currentStep;

        if (!this.canGoAhead()) {
            return false;
        }

        if (currentStep < this.getMaxSteps()) {
            this.setState(
                {currentStep: currentStep + 1},
                this.updateDialogActions.bind(this)
            )

            const onLeave = this.getChildProp("onLeave", currentStep);
            if (_.isFunction(onLeave)) {
                onLeave();
            }

            const onEnter = this.getChildProp("onEnter", currentStep + 1);
            if (_.isFunction(onEnter)) {
                onEnter();
            }
        }
    }

    setStep(step) {
        const currentStep = this.state.currentStep;

        if (currentStep < step && !this.canGoAhead()) {
            return (false);
        }

        if (step >= 1 && step <= this.getMaxSteps()) {
            this.setState(
                {currentStep: step},
                this.updateDialogActions.bind(this)
            )

            const onLeave = this.getChildProp("onLeave", currentStep);
            if (_.isFunction(onLeave)) {
                onLeave();
            }

            const onEnter = this.getChildProp("onEnter", step);
            if (_.isFunction(onEnter)) {
                onEnter();
            }
        }
    }

    canGoAhead() {
        if (this.props.canGoAhead) {
            return this.props.canGoAhead(this.state.currentStep);
        }

        return true;
    }

    updateDialogActions() {
        const {leftHeaderActions, rightHeaderActions} = this.getDialogActions();

        updateDialog({
            leftHeaderActions: leftHeaderActions,
            rightHeaderActions: rightHeaderActions,
        });
    }

    getNumberOfSteps() {
        return this.props.children.length;
    }

    finish() {
        if (!this.canGoAhead()) {
            return false;
        }

        if (_.isFunction(this.props.onFinish)) {
            const ret = this.props.onFinish();
            if (ret instanceof Promise) {
                ret.then(hideDialog).catch(e => console.error(e));
            }
        } else {
            hideDialog();
        }
    }

    getDialogActions() {
        const currentStep = this.state.currentStep,
            numberOfSteps = this.getNumberOfSteps(),
            leftHeaderActions = [],
            rightHeaderActions = [];

        if (currentStep == 1) {
            leftHeaderActions.push(
                {
                    id: "close-mobile",
                    type: ACTION_TYPES.ICON,
                    icon: "close",
                    className: "hidden-sm-up",
                    onClick: hideDialog,
                },
                {
                    id: "close-tabled",
                    type: ACTION_TYPES.BUTTON,
                    text: M("cancel"),
                    className: "btn-transparent-secondary hidden-xs-down",
                    onClick: hideDialog,
                },
            );
        }

        if (currentStep < numberOfSteps) {
            rightHeaderActions.push({
                id: "forward",
                type: ACTION_TYPES.BUTTON,
                text: M("forward"),
                className: "btn-transparent-primary",
                onClick: this.nextStep.bind(this),
                disabled: !this.canGoAhead(),
            });
        } else if (currentStep == numberOfSteps) {
            rightHeaderActions.push(
                {
                    id: "finish",
                    type: ACTION_TYPES.BUTTON,
                    text: this.props.finishText ?? M("finish"),
                    className: "btn-transparent-primary",
                    onClick: this.finish.bind(this),
                    disabled: !this.canGoAhead(),
                }
            );
        } else {
            throw new Error("currentStepNumber > numberOfSteps");
        }

        if (currentStep > 1) {
            leftHeaderActions.push(
                {
                    id: "back-mobile",
                    type: ACTION_TYPES.ICON,
                    icon: "arrow_back",
                    className: "hidden-sm-up",
                    onClick: this.prevStep.bind(this),
                },
                {
                    id: "back-tablet",
                    type: ACTION_TYPES.BUTTON,
                    text: M("back"),
                    className: "btn-transparent-secondary hidden-xs-down",
                    onClick: this.prevStep.bind(this),
                }
            );
        }
    
        
        return {
            leftHeaderActions: leftHeaderActions,
            rightHeaderActions: rightHeaderActions,
        }
    }

    onSelectItem(item) {
        const entity = this.getEntity(),
            selected = _.extend({}, this.state.selected || {});

        selected[entity] = item;

        this.setState({selected: selected},this.updateDialogActions.bind(this));
    }

    render() {
        const maxSteps = this.getMaxSteps(),
            currentStep = this.state.currentStep;

        return (
            <>
                <WizardPagination
                    paginationSteps={maxSteps}
                    currentStep={currentStep}
                    onStepClick={this.setStep.bind(this)}
                    subtitle={this.getChildProp("subtitle")}
                />
                {this.getChild()}
            </>
        )
    }
}

Wizard.Step = (props) => {
    return props.children;
}